/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";
import FontAwesome from 'react-fontawesome';

import './QuickEscapeAdder.css';
import EscapeForm from './EscapeForm';
import ReviewForm from './ReviewForm';
import RegisterForm from './RegisterForm';
import OzModalButton from './OzModalButton';
import Loading from './Loading';

import {
  createEscape,
  updateEscape,
  deleteEscape,
  getSuggestions,
  addEscape,
  createReview,
  listReviews,
  fetchUser,
} from '../../actions';


class QuickEscapeAdder extends Component {

  state = { };

  constructor(props) {
    super(props);
    console.log('did I find an escape?', escape);
  }

  escape() {
    if (this.state.escape) {
      return this.state.escape;
    }

    let escape = null;
    if (this.props.user && this.props.user.profile && this.props.room) {
      for (let e of this.props.user.profile.escapes) {
        if (e.room.id == this.props.room.id) {
          escape = e;
          break
        }
      }
    }

    return escape;
  }

  addEscape() {
    let room = this.props.room;
    let params = {
      escape: { didEscape: true },
      room: { roomId: room.id },
    };
    this.setState({ loading: true, registering: false });
    this.props.addEscape(params, { silent: true })
      .then(resp => {
        this.setState({ escape: resp, loading: false });
        console.log('added escape', resp);
        if (this.props.onDone) {
          this.props.onDone();
        }
        if (this.props.autoReview) {
          this.setState({ reviewing: true });
        }
      });
  }

  renderAdder() {
    return this.renderAdderButton(() => this.addEscape());
  }

  renderAdderButton(fn) {
    return (
      <div className="btn-quick-add" onClick={fn}>
        {this.state.loading && <div><Loading /></div>}
        {!this.state.loading && <span><FontAwesome name="plus-square" /> Add {this.props.autoReview ? 'Review' : 'Escape'}</span>}
      </div>
    );
  }

  review() {
    if (this.state.review) {
      return this.state.review;
    }
    let escape = this.escape();
    if (escape && escape.reviews && escape.reviews.length > 0) {
      return escape.reviews[0];
    }
    return null;
  }

  addReview(e, values) {
    e.preventDefault();
    console.log('ADD REVIEW', values);
    this.props.createReview(values)
      .then(resp => {
        console.log('create review resp', resp);
        if (resp.error) return;
        this.setState({ reviewing: false, review: resp.obj });
      });
  }

  saveChanges(e, values) {
    let escape = this.escape();
    this.props.updateEscape(escape.id, values.escape)
      .then(resp => {
        if (resp.error) return;
        this.setState({ editing: false, escape: resp.obj });
      });
  }

  renderEditor() {
    let escape = this.escape();
    if (!escape) return null;
    if (!this.props.user) return null;
    let profile = this.props.user.profile;
    let room = this.props.room;
    if (!room) return null;

    let reviewNode;

    console.log('rendering escape:', escape);

    let review = this.review();

    if (review) {
      reviewNode = (
        <div className="your-rating">Your rating: {review.percent}/100</div>
      );
    } else {
      reviewNode = (
        <OzModalButton
          modalTitle="Add Review"
          show={this.state.reviewing}
          onShow={() => this.setState({ reviewing: true })}
          onHide={() => this.setState({ reviewing: false })}
          >

          <div className="add-review"><FontAwesome name="plus-square" /> Add Review</div>

          <ReviewForm
            modal={true}
            values={{
                    profileId: profile.id,
                    escapeId: escape.id,
                    roomId: room.id,
                    }}
            errors={this.props.errors.review}
            onSubmit={(e, values) => this.addReview(e, values)}
            onCancel={() => this.setState({ reviewing: false })}
            buttonText="Add Review"
            cancelText="Cancel"
            room={room}
          />

        </OzModalButton>
      );
    }

    return (
      <div className="edit">
        <div className="escape-button">
          <OzModalButton
            modalTitle="Edit Escape"
            show={this.state.editing}
            onShow={() => this.setState({ editing: true })}
            onHide={() => this.setState({ editing: false })}
          >
            <div className="escape-outcome editable">
              {escape.didEscape && <div className="outcome yes"><FontAwesome name="edit" /> ESCAPED!</div>}
              {!escape.didEscape && <div className="outcome nope"><FontAwesome name="edit" /> Nope...</div>}
            </div>
            <EscapeForm
              modal={true}
              values={escape}
              errors={this.props.errors.escape}
              onCancel={() => this.setState({ editing: false })}
              onSubmit={(e, values) => this.saveChanges(e, values)}
              buttonText="Save"
              cancelText="Cancel"
            />
          </OzModalButton>

          {reviewNode}

        </div>
      </div>
    )
  }

  renderSignupFlow() {
    let room = this.props.room
    let fn = () => {};
    return (
      <div>
          <OzModalButton
            modalTitle={'Add Escape from ' + room.name}
            show={this.state.registering}
            onShow={() => this.setState({ registering: true })}
            onHide={() => this.setState({ registering: false })}
          >
            {this.renderAdderButton(fn)}

            <div className="quick-escape-register">
              <p className="blurb">To add your escape from <b>{room.name}</b>, sign up below. You'll be able to add more escapes and join discussions about rooms you've done!</p>
              <RegisterForm
                doRegister
                values={{}}
                errors={this.props.errors.register}
                modal={true}
                onCancel={() => this.setState({ registering: false })}
                onSuccess={() => this.addEscape()}
                cancelText="Cancel"
                buttonText={'Sign Up & Add ' + room.name}
              />
            </div>
          </OzModalButton>
      </div>
    )
  }

  render() {
    if (!this.props.room) return null;

    let body;
    if (!this.props.user || !this.props.user.profile) {
      body = this.renderSignupFlow();
    } else {
      let escape = this.escape();
      body = (
        <div>
          {!escape && this.renderAdder()}
          {escape && this.renderEditor()}
        </div>
      )
    }

    return (
      <div className={cx('QuickEscapeAdder', this.props.size)}>
        {body}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    addEscape,
    updateEscape,
    createReview,
    fetchUser,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuickEscapeAdder);



/** WEBPACK FOOTER **
 ** ./src/components/partials/QuickEscapeAdder.js
 **/